import React, { useEffect, useState } from 'react';

import { CollapseDown, CollapseUp, NextArrow } from '../../assets/icons';

import { DATE_FORMAT, formatDate } from '../../utils/dateFormat.helper';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';

import './PortfolioTableMobile.scss';
const PortfolioTableMobile = (props) => {
  const { tableData, count = 0, handleOnScrollIntoView = () => {} } = props;
  // const [navOpen, setNavOpen] = useState(false);
  // const [loadingMsg, setloadingMsg] = useState('Loading...');
  //pagination hooks
  // const ref = useRef(null);
  // const [isIntersecting, setIsIntersecting] = useState(false);
  // function for scroll pagination
  // const handlePagination = () => {
  //   if (totalPage > currentPage) {
  //     setPageOnMobileOpenOrder(currentPage + 1);
  //   } else {
  //     setloadingMsg('');
  //   }
  // };
  // const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), []);
  // useEffect(() => {
  //   if (isIntersecting) {
  //     handlePagination();
  //   }
  //   observer.observe(ref.current);
  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [ref, observer, isIntersecting]);
  const [currentCount, setCurrentCount] = useState(3);

  useEffect(() => {
    if (!props.isOrder) {
      setCurrentCount(count);
    }
  }, [count, props.isOrder]);

  return (
    <div className='portfoliotablemobile'>
      <div className='container-fluid'>
        <div className='portfoliotablemobile__head'>
          <h4>{props.PortfolioTableMobileHead}</h4>
          <span>Total value</span>
        </div>
        <ul className='portfoliotablemobile__data'>
          {tableData?.slice(0, currentCount).map((order) => {
            const {
              openOrderId = '',
              propertyName = '',
              property = '',
              type = '',
              totalPrice = '',
              quantity = '',
              status = '',
              totalValue = '',
              createdAt,
            } = order;
            return (
              <li className='portfoliotablemobile__datablock' key={openOrderId}>
                {props?.isOrder && <span className='openOrder__date'>{formatDate(createdAt, DATE_FORMAT.DATE_FORMAT_SHORT)}</span>}
                <div className='title'>
                  {props?.isOrder ? property : propertyName}{' '}
                  <NextArrow className='cursor-pointer' color='#1A1519' size={10} onClick={() => props.onOpen(order)} />
                </div>
                <div className='sellvalue'>
                  {props.isOrder ? (
                    <p>
                      {type}: {status}
                    </p>
                  ) : (
                    <p>{getUsCurrencyFormatWithoutDecimal(Number(quantity) || 0)} shares</p>
                  )}
                  <span>${getUsCurrencyFormat(Number(props?.isOrder ? totalPrice : totalValue) || 0)}</span>
                </div>
              </li>
            );
          })}
        </ul>
        {props.isOrder && count > 3 ? (
          currentCount < tableData?.length ? (
            <div
              className='show-toggle cursor-pointer'
              onClick={(e) => {
                e.stopPropagation();
                setCurrentCount(tableData.length);
              }}
            >
              <span>Show All ({count})</span>
              <CollapseUp color='#8A4743' size='12' />
            </div>
          ) : (
            <div
              className='show-toggle cursor-pointer'
              onClick={(e) => {
                e.stopPropagation();
                setCurrentCount(3);
                handleOnScrollIntoView();
              }}
            >
              <span>See less</span>
              <CollapseDown color='#8A4743' size='12' />
            </div>
          )
        ) : (
          <></>
        )}
        {/* <div ref={ref}>{loadingMsg}</div> */}
      </div>
    </div>
  );
};

export default PortfolioTableMobile;
